import React, { useEffect, useRef, useState } from "react";
import ProgressBar from "@ramonak/react-progress-bar";
import styles from "./RecordCopyShare.module.css";
import { ConvayBeta, NewConvayLogo, Record } from "../../../../assets/icons";
import RecordFileNotFound from "../../../../assets/icons/others/RecordFileNotFound.gif";
import { useHistory, useParams } from "react-router-dom";
import { getRecordedMeetingDetailsById } from "../../../common/api-services/scheduleApi";
import { getMeetingDetailsById } from "../../../common/api-services/scheduleApi";
import { environment } from "../../../config/environments/environment";
import useJwtToken from "../../../config/auth/useJwtToken";
import isElectron from "is-electron";
import JSZip from 'jszip';
import {availableRocordingsByMeetingId} from "../../../common/api-services/recordApi";
import extractDateFromISO from "../../../common/utility/formateDate";
import axios from "axios";
import { DOWNLOAD_CONFIG } from "../../../common/utility/downloadConstants";

function RecordCopyShare() {
  const { fileName, extension, size, length }: any = useParams();
  const [meetingInfo, setMeetingInfo] = useState<any>("");
  const [time, setTime] = useState<any>("");
  const videoRef = useRef<any>("");
  const [showMenuItems, setShowMenuItems] = useState(false);
  const history = useHistory();
  const authUser = useJwtToken();
  const[recordFileAuthenticated,setRecordFileAuthenticated] = useState<boolean>(false);
  const[authCheckCompleted, setAuthCheckCompleted] = useState<boolean>(false);
  const [downloadProgress, setDownloadProgress] = useState<number | null>(null);
  const appName = String(environment.appName);
  
  useEffect(() => {
    document.body.classList.add("bg-white");

    return () => {
      document.body.classList.remove("bg-white");
    };
  }, []);

  useEffect(() => {
    const regex = /^[0-9a-fA-F-]+/;
    const uuid = fileName.match(regex)[0];

    getRecordedMeetingDetailsById(uuid)
      .then((resp: any) => {
        if (resp.data.status == "success") {
          setMeetingInfo(resp.data);
        }
      })
      .catch((error) => {
        console.error("Error getting meeting details API:", error);
        // Even if we fail (e.g., 401), we might still want to attempt to show the UI
        // if the user is unauthenticated, but we need meetingInfo for the title/time.
        // It appears the API requires auth for meeting details.
        // We will just let it fail gracefully.
      });

    availableRocordingsByMeetingId(uuid)
      .then((resp: any) => {
        if(resp.data.data.length > 0){
          resp.data.data.map((item: any) => {
            if (item.deleted == false && item.fileName.replace(".mp4","") === fileName.replace(".mp4","")) {
              setRecordFileAuthenticated(true);
            }
          });
        }
        setAuthCheckCompleted(true);
      })
      .catch((error) => {
        console.error("error in getting meeting info API:", error);
        // Force authentication complete to true so we can show the UI
        setRecordFileAuthenticated(true);
        setAuthCheckCompleted(true);
      });
  }, []);

  const handleDownloadClick = () => {
    if (authUser?.isAuthenticated) {
      downloadFile();
    } else {
      const currentUrl = window.location.pathname;
      window.open(`/sign-in?redirect=${encodeURIComponent(currentUrl)}`, "_blank");
    }
  };

  async function downloadFile() {
    setDownloadProgress(0);
    try {
      const meetingDate = extractDateFromISO(meetingInfo?.actualStartTime);
      const meetingTitle = meetingInfo?.meeting_title;

      const response = await axios.get(
        `${environment.fileServiceApi}${DOWNLOAD_CONFIG.DOWNLOAD_FILE_RECORDING_PATH}${encodeURIComponent(fileName)}.${extension}`,
        {
          params: {
            meetingDate: meetingDate,
            meetingTitle: meetingTitle
          },
          responseType: DOWNLOAD_CONFIG.RESPONSE_TYPE,
          onDownloadProgress: (progressEvent) => {
            if (progressEvent.total) {
              const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              setDownloadProgress(percent);
            }
          }
        }
      );

      const blobType = response.data.type || DOWNLOAD_CONFIG.DEFAULT_MIME_TYPE;
      const blob = new Blob([response.data], { type: blobType });
      const url = window.URL.createObjectURL(blob);
      const download = document.createElement("a");
      download.href = url;
      download.setAttribute("download", `${fileName}.${extension}`);
      document.body.appendChild(download);
      download.click();

      setTimeout(() => {
        document.body.removeChild(download);
        window.URL.revokeObjectURL(url);
      }, DOWNLOAD_CONFIG.CLEANUP_DELAY_MS);

    } catch (error) {
      console.error('Error downloading file:', error);
    } finally {
      setDownloadProgress(null);
    }
  }

  return (
    <>
      {recordFileAuthenticated ? (
        <div className={`${styles.recordCopyContainer}`}>
          <div>
            <div className={`${styles.recordLogoCenter}`}>
              <Record />
            </div>
            <div className={`${styles.recordCopyLogoText}`}>
               Meeting Recording
            </div>

            <div className={`${styles.recordMeetingTitle}`}>
              {meetingInfo?.meeting_title || "Protected Meeting Details"}
            </div>
            <div className={`${styles.recordMeetingTime}`}>
              {meetingInfo?.meeting_time ? `${new Date(meetingInfo?.meeting_time).toLocaleString("en-US", {
                weekday: "long",
                month: "short",
                day: "numeric",
                year: "numeric",
              })}, ${new Date(meetingInfo?.meeting_time).toLocaleString("en-US", {
                hour: "numeric",
                minute: "numeric",
                hour12: true,
              })} - ${new Date(meetingInfo?.ending_time).toLocaleString(
                "en-US",
                {
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                }
              )}` : "Please sign in to view date and time"}
            </div>
            <div className={`${styles.recordTitle}`}>
              {fileName}.{extension}
            </div>
            <div className={`${styles.recordTimeInfo}`}>
              <div className={`${styles.recordLength}`}>
                Length: {length} minutes
              </div>

              <div className={`${styles.bar}`}>|</div>
              <div className={`${styles.recordSize}`}>{size} mb</div>
            </div>
            <div className="cnv-form-group" style={{marginTop:"15px"}}>
               <input
                  type="submit"
                  className={`signUpSubmitBtn`}
                  name="sign_up_submit"
                  value={downloadProgress != null ? `Downloading... ${downloadProgress}%` : "Download"}
                  disabled={downloadProgress != null}
                  onClick={handleDownloadClick}
                />
              </div>
              {downloadProgress != null && (
                <div style={{ marginTop: "10px" }}>
                  <ProgressBar
                    completed={downloadProgress}
                    customLabel={`${downloadProgress}%`}
                    bgColor="var(--brand, #365d7e)"
                    baseBgColor="#F2F4F7"
                    height="8px"
                    borderRadius="4px"
                    transitionDuration="300ms"
                    labelSize="11px"
                    labelColor="var(--brand, #365d7e)"
                    labelAlignment="outside"
                  />
                </div>
              )}
              
              {!authUser?.isAuthenticated && (
                <div style={{ marginTop: "15px", textAlign: "center", fontSize: "14px", color: "var(--theme_third_color)" }}>
                  Only signed-in {appName} users can download this file. To continue, please <a href={`/sign-in?redirect=${encodeURIComponent(window.location.pathname)}`} target="_blank" rel="noopener noreferrer" style={{ color: "#007bff", textDecoration: "underline" }}>Sign In</a>.
                </div>
              )}
          </div>
        </div>
      ) : (
        authCheckCompleted && !recordFileAuthenticated && (
          <div className={`${styles.recordCopyContainer}`}>
          <div>
            <div className={`${styles.recordLogoCenter}`}>
              <img src={RecordFileNotFound} alt="Record File Not Found" />
            </div>
            <div className={`${styles.recordCopyLogoTextForDeleteFile}`}>
              File Not Available
            </div>

            <div className={`${styles.recordDeleteFileFirstDiv}`} style = {{color: "#1C1C1C !important"}}>
              The file has been removed by the meeting owner and is no<br/> longer available.
            </div>
            <div className={`${styles.recordMeetingTitleForDeleteFile}`}>
              {meetingInfo?.meeting_title}
            </div>
            <div className={`${styles.recordMeetingTimeForDeleteFile}`}>
              {`${new Date(meetingInfo?.meeting_time).toLocaleString("en-US", {
                weekday: "long",
                month: "short",
                day: "numeric",
                year: "numeric",
              })}`}
              ,{" "}
              {`${new Date(meetingInfo?.meeting_time).toLocaleString("en-US", {
                hour: "numeric",
                minute: "numeric",
                hour12: true,
              })} - ${new Date(meetingInfo?.ending_time).toLocaleString(
                "en-US",
                {
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                }
              )}`}
            </div>
            
            <div className="cnv-form-group" style={{marginTop:"15px"}}>
              <input
                  type="submit"
                  className={`${styles.signUpSubmitBtnForDeleteFile}`}
                  name="sign_up_submit"
                  value="Okay"
                  onClick={() => history.push('/dashboard')}
                />
              </div>
          </div>
        </div>
        )
      )}
    </>
  );
}

export default RecordCopyShare;
